import { OktaAuth } from "@okta/okta-auth-js";
import type { PortalAuthConfig } from "../api/portalConfig";

// Module-level OktaAuth holder. Set once at app bootstrap by
// <PortalConfigProvider> after /api/portal-config resolves; read by
// non-React code (fetchWithAuth in api/client.ts) that can't subscribe
// to a React context.
//
// Why a module global instead of pure context: fetchWithAuth is plain
// async TS called from event handlers and effects, not inside a render
// tree. It needs synchronous access to the same OktaAuth instance the
// <Security> wrapper is using. The holder pattern keeps both ends
// pointing at one object without making the entire data-fetch layer
// React-aware.

let _oktaAuth: OktaAuth | null = null;

export function setOktaAuthFromConfig(auth: PortalAuthConfig): void {
  if (!auth.okta_enabled || !auth.issuer || !auth.client_id) {
    _oktaAuth = null;
    return;
  }
  _oktaAuth = new OktaAuth({
    issuer: auth.issuer,
    clientId: auth.client_id,
    redirectUri: window.location.origin + "/login/callback",
    scopes: ["openid", "profile", "email", "groups"],
    pkce: true,
  });
}

export function getOktaAuth(): OktaAuth | null {
  return _oktaAuth;
}

export function isOktaEnabled(): boolean {
  return _oktaAuth !== null;
}
